module.exports = __webpack_public_path__ + "static/media/advertManImage.61c3868a.png";